import PropTypes from 'prop-types';

import DefaultLayout from './DefaultLayout/DefaultLayout';
import RawLayout from './RawLayout/RawLayout';

export const LayoutTemplates = {
	default: 'default',
	raw: 'raw',
};

/**
 * Page Layout
 * @component
 * @param {string} layout - Layout type (one of LayoutTemplates types)
 * @param {string} title - Page title for the browser tab
 * @param {node} children - Page content
 */
const Layout = ({ layout = LayoutTemplates.default, title, children }) => {
	if (layout === LayoutTemplates.default) {
		return <DefaultLayout title={title}>{children}</DefaultLayout>;
	} else if (layout === LayoutTemplates.raw) {
		return <RawLayout title={title}>{children}</RawLayout>;
	} else {
		return children;
	}
};

Layout.propTypes = {
	// Page Layout
	layout: PropTypes.string,
	// Page title for the browser tab
	title: PropTypes.string.isRequired,
	// Page content
	children: PropTypes.node.isRequired,
};

export default Layout;
